import React from 'react';

import { PalmTree } from '@/app/shared/svgComponents/PalmTree';

interface FaqPageContainerProps {
  centerContent?: React.ReactNode;
  heading?: string;
}

const FaqPageContainer = ({ centerContent, heading = 'FAQ' }: FaqPageContainerProps) => {
  return (
    <div className='border-decoration-stroke box-border flex min-h-[calc(100vh-230px)] flex-col md:mx-[23px] md:min-h-[calc(100vh-130px)] md:border-x'>
      <div className='border-decoration-stroke h-[172px] w-full border-b' />

      <div className='grid min-h-0 flex-1 md:grid-cols-[1fr_632px_1fr]'>
        <div className='border-decoration-stroke relative hidden h-full flex-col border-r md:flex'>
          <div className='text-decoration-stroke pointer-events-none absolute -top-[34px] -right-[34px] z-20'>
            <PalmTree />
          </div>

          <div className='h-22 w-full border-b border-decoration-stroke'>
            <div className='h-full w-full opacity-30' style={{ background: 'linear-gradient(270deg, var(--decoration-stroke) 0%, var(--background) 100%)' }} />
          </div>

          <div className='border-decoration-stroke h-2.5 w-full border-b' />
          <div className='border-decoration-stroke h-2.5 w-full border-b' />
          <div className='flex-1 p-4'></div>
        </div>

        <div className='border-decoration-stroke relative flex h-full w-full flex-col md:border-r'>
          <div className='text-decoration-stroke pointer-events-none absolute -top-[34px] -right-[34px] z-20 hidden md:block'>
            <PalmTree />
          </div>

          <div className='border-decoration-stroke flex h-22 w-full items-stretch justify-center border-b'>
            <div className='border-decoration-stroke flex items-center justify-center border-x px-8'>
              <p className='text-[28px] font-normal text-gray-50 md:text-4xl'>{heading}</p>
            </div>
          </div>
          <div className='border-decoration-stroke h-2.5 w-full border-b' />
          <div className='border-decoration-stroke h-2.5 w-full border-b' />
          <div className='flex-1'>{centerContent}</div>
        </div>

        <div className='hidden h-full flex-col md:flex'>
          <div className='h-22 w-full border-b border-decoration-stroke'>
            <div className='h-full w-full opacity-30' style={{ background: 'linear-gradient(90deg, var(--decoration-stroke) 0%, var(--background) 100%)' }} />
          </div>

          <div className='border-decoration-stroke h-2.5 w-full border-b' />
          <div className='border-decoration-stroke h-2.5 w-full border-b' />
          <div className='flex-1 p-4'></div>
        </div>
      </div>
    </div>
  );
};

export default FaqPageContainer;
